import React from 'react';
import PropTypes from 'prop-types';
import AppService from '../service/AppService';
import AppConfigService from '../service/AppConfigService';
import type AppConfig from '../domain/AppConfig';
const appConfig:AppConfig = AppService.appConfig();

export default class CategoryItem2 extends React.Component {

  static propTypes = {
    parentDisplayCategoryId: PropTypes.number.isRequired,
    productCategory: PropTypes.shape({
      name: PropTypes.string.isRequired,
      displayCategoryId: PropTypes.number.isRequired,
      itemCount: PropTypes.number.isRequired,
      disableMarketplaceBanner: PropTypes.bool,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { over: false };
  }

  onClick() {
    let {
      name,
      displayCategoryId,
    } = this.props.productCategory;

    if (!this.props.disableMarketplaceBanner) {
      window.location.href = `${appConfig.marketplaceWebHost}/${appConfig.langCode}/s/item/?rf=1108&fc=%7C${this.props.parentDisplayCategoryId}%7C${displayCategoryId}&k=`;
    } else if (AppConfigService.shouldShowMarketplaceTopBanner()) {
      window.location.href = `${appConfig.searchWebHost}/${appConfig.langCode}/s/item/?rf=1108&fc=%7C${this.props.parentDisplayCategoryId}%7C${displayCategoryId}&k=`;
    } else {
      window.location.href = `${appConfig.searchWebHost}/${appConfig.langCode}/c/2/${encodeURIComponent(name)}/${this.props.parentDisplayCategoryId}/${displayCategoryId}/index.html`;
    }
  }

  render() {

    let {
      name,
      itemCount,
    } = this.props.productCategory;

    return (
      <div className="categoryItem" onClick={::this.onClick}>
        <p className="name">
          <span>{name}</span>
          <span className="number">({itemCount.toLocaleString('en')})</span>
        </p>
      </div>
    )
  }

}